var map = {
	"./contact": [
		2615,
		642,
		605,
		621,
		215,
		631
	],
	"./contact.js": [
		2615,
		642,
		605,
		621,
		215,
		631
	],
	"./default": [
		87584,
		642,
		621,
		913
	],
	"./default.js": [
		87584,
		642,
		621,
		913
	],
	"./events": [
		82176,
		642,
		605,
		621,
		215,
		136
	],
	"./events.js": [
		82176,
		642,
		605,
		621,
		215,
		136
	],
	"./gallery": [
		49505,
		642,
		621,
		121
	],
	"./gallery.js": [
		49505,
		642,
		621,
		121
	],
	"./home": [
		47589,
		642,
		621,
		177
	],
	"./home.js": [
		47589,
		642,
		621,
		177
	],
	"./menu": [
		85008,
		642,
		621,
		860
	],
	"./menu.js": [
		85008,
		642,
		621,
		860
	],
	"./press": [
		23367,
		642,
		621,
		342
	],
	"./press.js": [
		23367,
		642,
		621,
		342
	],
	"./weddings": [
		99981,
		642,
		605,
		621,
		215,
		466
	],
	"./weddings.js": [
		99981,
		642,
		605,
		621,
		215,
		466
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 91559;
module.exports = webpackAsyncContext;